import React from "react"
import { MdInsertChart, MdArrowForward } from "react-icons/md"
import { AnchorButton } from "gatsby-interface"
import DonutChart from "@modules/metrics/components/DonutChart"
import {
  ReportSection,
  ReportRow,
  ReportName,
  ReportDetails,
  ReportDetailsItem,
} from "./MiniReport.helpers"
import useLighthouseScoresForBuild from "../hooks/useLighthouseScoresForBuild"

function MiniReport({ siteId, buildId, branch }) {
  const [lighthouseScores, { loading }] = useLighthouseScoresForBuild(
    siteId,
    buildId,
    branch
  )

  if (loading || lighthouseScores.length === 0) {
    return null
  }

  return (
    <ReportSection>
      <ReportRow>
        <ReportName>
          <MdInsertChart />
          <strong>Lighthouse</strong> scores:
        </ReportName>
        <ReportDetails>
          {lighthouseScores.map((item, idx) => (
            <ReportDetailsItem key={idx}>
              {item[0]} <DonutChart value={item[1]} />
              <b>{item[1]}</b>
            </ReportDetailsItem>
          ))}
        </ReportDetails>
        <AnchorButton
          size={`M`}
          variant={`SECONDARY`}
          target="_blank"
          href={`https://build-${buildId}${process.env.GATSBY_PREVIEW_DOMAIN}/reports/lighthouse/index.html`}
          rightIcon={<MdArrowForward />}
        >
          Full Report
        </AnchorButton>
      </ReportRow>
    </ReportSection>
  )
}

export default MiniReport
